import { useFormContext } from 'react-hook-form'

import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

import { SchemaType } from '@/components/forms/AddBucketForm/AddBucketForm.schema'

const bucketTypes = ['TOP_LEVEL', 'INVESTMENT_TYPE', 'WRAPPER'] as const

const bucketTypeOptions = bucketTypes.map((item) => ({
  label: item,
  value: item,
}))

export interface AddBucketFormFieldsProps {}

export const AddBucketFormFields: React.FC<AddBucketFormFieldsProps> = ({}) => {
  const { setValue, control, formState, register } = useFormContext<SchemaType>()

  return (
    <div className={'flex flex-col gap-4'}>
      <FormField
        name="bucket_name"
        control={control}
        render={() => {
          return (
            <FormItem>
              <FormLabel>Bucket Name</FormLabel>
              <Input
                inputSize={'sm'}
                className={'w-full'}
                disabled={formState.isSubmitting}
                {...register('bucket_name')}
              />
            </FormItem>
          )
        }}
      />
      <FormField
        name={'bucket_type'}
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Bucket Type</FormLabel>
              <SelectInput
                value={value}
                options={bucketTypeOptions}
                onValueChange={(val) =>
                  setValue('bucket_type', val as (typeof bucketTypeOptions)[number]['value'], {
                    shouldValidate: true,
                  })
                }
              />
            </FormItem>
          )
        }}
      />
    </div>
  )
}
